import React from "react";
import { Divider, Space, Table, Button } from "antd";
import axios from "axios";

const columns = [
  {
    title: "Start Date",
    dataIndex: "disaster_start_date",
    
  },
  {
    title: "Name",
    dataIndex: "name",
    
  },
  {
    title: "Disaster Type",
    dataIndex: "dtypename",
    
  },
  {
    title: "Glide",
    dataIndex: "glide",
    
  },
  {
    title: "Requested Amount",
    dataIndex: "areq",
    
  },
  {
    title: "# Affected",
    dataIndex: "num_affected",
    
  },
];

const SectionThree = (props) => {
  let y = new Date();
  let y1 = y.getUTCFullYear() - 1;
  let m = y.getUTCMonth() + 1;
  let d = y.getDate();



  const url =
    "https://goadmin.ifrc.org/api/v2/event/?limit=5&ordering=-disaster_start_date&disaster_start_date__gte="+y1+"-"+m+"-"+d+"T00%3A00%3A00.000Z&countries__in=194&offset=0";

  const [post, setPost] = React.useState(null);

  React.useEffect(() => {
    axios.get(url).then((response) => {

      for (var i = 0; i < response.data.results.length; i++) {
        response.data.results[i].disaster_start_date =
        response.data.results[i].disaster_start_date.substring(0,10);
        // eslint-disable-next-line no-unused-expressions
        response.data.results[i].dtypename =
          response.data.results[i].dtype.name;
          if(response.data.results[i].appeals && response.data.results[i].appeals.length>0 )
          response.data.results[i].areq = response.data.results[i].appeals[0].amount_requested;
      }

      setPost(response.data);
      // console.log(nyamka)
      // console.log(date.toISOString().split('T')[0]);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!post) return null;

  return (
    <>
        <div class="row pt-50">
              <div class="col-md-12">
                <div class="tabbable-panel">
                  <Divider orientation="left">
                    <h3>
                      RECENT EMERGENCIES ({post.count}){" "}
                      <Button type="link" href="/emergencies">
                        View All Emergencies For Mongolia
                      </Button>{" "}
                      <Space orientation="right"></Space>{" "}
                    </h3>
                  </Divider>

                  <Table dataSource={post.results} columns={columns} />
                </div>
              </div>
            </div>
    </>
  );
};
export default SectionThree;
